"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useView = exports.useScreen = exports.useRenderer = exports.Renderer = exports.RendererContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _hooks = require("./hooks");

var _View = require("./UI/View");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RendererContext = (0, _react.createContext)(undefined);
exports.RendererContext = RendererContext;
RendererContext.displayName = 'Renderer';
var Renderer = (0, _View.withView)('Renderer', function (_ref) {
  var children = _ref.children,
      create = _ref.create,
      width = _ref.width,
      height = _ref.height;
  var view = (0, _react.useContext)(_View.ViewContext);
  var renderer = (0, _hooks.useCloseable)(function () {
    return create ? create(view) : new PIXI.Renderer({
      view: view
    });
  });
  if (width != null && height != null && (width !== renderer.width || height !== renderer.height)) renderer.resize(width, height);
  return _react.default.createElement(RendererContext.Provider, {
    value: renderer
  }, children);
}, {
  Creator: function Creator(options) {
    return (0, _react.useMemo)(function () {
      return {
        create: function create(view) {
          return new PIXI.Renderer(_objectSpread({
            view: view
          }, options));
        }
      };
    }, []);
  }
});
exports.Renderer = Renderer;

var useRenderer = function useRenderer() {
  return (0, _react.useContext)(RendererContext);
};

exports.useRenderer = useRenderer;

var useScreen = function useScreen() {
  var renderer = (0, _react.useContext)(RendererContext);
  return renderer && renderer.screen;
};

exports.useScreen = useScreen;

var useView = function useView() {
  var renderer = (0, _react.useContext)(RendererContext);
  return renderer && renderer.view;
};

exports.useView = useView;